import { render } from "./TextLight.vue?vue&type=template&id=b0db578a&scoped=true&bindings={\"size\":\"props\",\"weight\":\"props\",\"align\":\"props\",\"action\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./TextLight.vue?vue&type=script&lang=js"
export * from "./TextLight.vue?vue&type=script&lang=js"

import "./TextLight.vue?vue&type=style&index=0&id=b0db578a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0db578a"

export default script